module.exports = __webpack_public_path__ + "static/media/attendance.7d4fe195.svg";